import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { Reveal } from "@/components/Reveal";
import Icon from "@/components/Icon";
import { SERVICES } from "@/data/site";

// Uniform text-only cards
const SPANS = ["", "", "", "", "", ""];

export default function ServicesGrid() {
  return (
    <section id="servicos" className="bg-brand-coal py-24 md:py-32" data-testid="services-grid">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-red">Nossos Serviços</p>
            <h2 className="mt-4 font-display text-4xl uppercase leading-[0.95] tracking-tight text-white md:text-6xl">
              Soluções completas<br />em resgate
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-white/55">
            Do carro de passeio à carreta pesada — atendemos qualquer emergência com a frota certa e
            equipe especializada.
          </p>
        </Reveal>

        <div className="grid auto-rows-[220px] grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 3) * 0.06} className={SPANS[i] || ""}>
              <Link
                to={`/servicos#${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className="group relative flex h-full flex-col justify-between overflow-hidden rounded-sm border border-white/10 bg-brand-obsidian p-6 transition-colors duration-300 hover:border-brand-red"
              >
                <div className="pointer-events-none absolute -right-8 -top-8 h-32 w-32 rounded-full bg-brand-red/5 blur-2xl transition-opacity duration-500 group-hover:bg-brand-red/15" />
                <div className="relative flex items-start justify-between">
                  <Icon name={s.icon} weight="light" className="h-9 w-9 text-brand-red" />
                  <ArrowUpRight className="h-6 w-6 text-white/40 transition-all duration-300 group-hover:text-brand-red group-hover:translate-x-1 group-hover:-translate-y-1" />
                </div>
                <div className="relative">
                  <h3 className="font-heading text-xl font-semibold uppercase tracking-wide text-white md:text-2xl">{s.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-white/55">{s.short}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
